import React from 'react';
// styles and images
import styles from './Graphics.module.css';

/*****************************************
 * * Create SVG Content
 *****************************************/
export function createContent2() {
  let content = [];
  let pathRefs = [];

  // content.push(
  //   <rect key='background' className={styles.st0} width='800' height='400' />
  // );

  content.push(
    <path
      key='dog1'
      className={styles.dog}
      d='M98.6,21c-0.2-0.3-0.7-1.1-1.4-1.1c-0.2,0-0.4,0.1-0.6,0.2c-0.7,0.6-1,2.4-0.6,3.3c0.2,0.3,0.8,1.3,1.6,1.3   c0.4,0,0.9-0.2,1.2-1.1C99.3,22.2,98.7,21.2,98.6,21z M26,76.1c-0.8-0.8-3.5-2.1-2.7-5.6s4-6,4-6l-3.1-1.1c0,0-2.3,2.6-3.7,4c-1.5,1.5-4.4,5.8-5.5,6.1c0,0,2.1,2.6,4.7,6   c0,0,6.4,2.1,7.3,2.1s5.2-0.5,3.9-3.1C29.5,76,26.8,76.9,26,76.1z M75.8,76.4c-0.2-1,0.5-0.2,0.6-4c0.2-3.9-0.2-8.9,0.3-11.9l-4.4,5.6l-0.2,7.1l-0.5,8.9c0,0,1.5,0,3.2,0   c1.8,0,4.7,0.3,4.4-2.3C79,77.3,76,77.4,75.8,76.4z M97.6,25.4c-1.2,0-1.9-1.1-2.1-1.6c-0.6-1.1-0.2-3.1,0.7-4c-0.3-0.4-0.6-0.8-1-1.1c-0.2-0.2-0.5-0.3-0.7-0.4   c-1.2,1.1-0.8,1.9-0.8,1.9c0.3,2.7-0.5,4.2-1.1,5.5c-0.6,1.3-1.5,4.5-1.5,4.5c-0.3-2.7,1-6.3,1.4-7.7s-0.1-4.2-0.1-4.2   c0.6,0,1.1-0.8,1.4-1.4c-0.3-1.9-1-5.3-2.9-6.7c-2.6-1.9-11-2.6-15.3-0.9c-4.3,1.7-8.2,6.7-8.2,6.7s-1.7,1.2-4,3.1   c-1,0.2-2.8,0.6-3.3,1.2c-0.6,0.8-0.6,1.9-0.6,1.9c0.2,1.4,0.6,3.4,1.3,4.1c1.1,1.1,3.2,6.1,3.2,6.1s-4.4-4.5-4.7-5.2   c-0.2-0.4-1.1-2.2-2-3.7c0,0-1.9-0.6-3.2,0c-0.4,0.2-1,1.2-1.4,1.9c-2.2,0.8-4.1,1.2-5.1,1.4c-5.9,0.9-11.9-2.2-19.8-2.8   c0,4-5.3,5.2-5.3,5.2c-6,0.4-8.6-1.1-9.7-2.8c0,0,0,0,0,0c-1.1-1.6-0.8-3.3-0.8-3.3c0.7-3.6,2.5-6.1,4.2-7.8   C8.5,15,5.5,23.1,5.5,23.1c-1.5,3.2,0.3,7,1.3,8.7c-1.4,2.1-2.4,4.5-2.9,7.1c-1.3,6.4,2.4,16.3,1.5,23c-0.5,4.1-2.5,5.4-3.4,6.8   c-0.7,1-1,2.3-0.9,3.5L2.4,86c0,0,0.9,4.9,1.9,5.4c1.1,0.4,7.5,1.1,7.5-2.4s-3.4-3.2-3.4-3.2l1.3-8.6c0,0-0.2-1.3,2.4-3.4   c2.6-2.1,8.8-9.7,8.8-9.7c0.2-0.5,0.4-1,0.7-1.4c5.9-10.9,2.3-19.4,2.3-19.4c3.9,6.8,1.8,15.6,1.2,17.8c0.9,0,1.9,0.3,3.1,0.7   c6.9,2.4,12.3,3.8,16.6,4.5c0.9,0.2,2.6,0.5,3.3,0.7c1,0.3,2.6-0.1,2.6-0.1s0,0,0,0c0.8,0,1.5,0,2.2,0l0,0c0,0,2.2,1.5,4.6-0.6   c0,0,0.1,0,0.1,0c-0.1-2.2-0.3-5-0.5-7.9l2.5,6.8c0.6,6,2.4,12.5,2.4,14.4s1.5,3.2,1.5,3.2s0.9,1.9,0.9,4.5c0,2.6,3.4,2.4,3.4,2.4   s6.9,0.4,6.9-1.7c0-2.1-4.5-3.2-4.5-3.2s-0.2-5.4,0-8.8c0.2-3.4,0.4-11.6,0.4-11.6c0,0,0,0,0,0c0-0.8,0-2.3,0.2-4.6   c0.5-3.9,2.6-5,2.6-5c-1.1,3.6-1.1,6.5-1,8.2c2.2-2.3,4.2-6.5,6.1-9.3c1.2-1.8,2.1-1.9,1.5-8.4c0,0-0.2-1.9,1.5-3.2   c1.7-1.3,4.1-2.6,4.5-5.4c0-0.3,0.1-0.6,0.1-0.9l1.8,0l0,0c0,0,0,0,0,0c0,0,3.2,1.1,4.3-1.9c0,0,2.6-0.4,4.3-3.7   C97.7,28,97.8,26.5,97.6,25.4C97.6,25.4,97.6,25.4,97.6,25.4z M79.1,29.7c-2.2,0.4-3.9-0.5-5.1-1.4c-1-0.8-1.7-1.9-2.1-3.1   l-0.8-2.2c0.6-0.2,2.5,4.3,5.5,5.1c3.1,0.8,4.1-0.8,4.1-2.3s-1.2-4.3-1.4-6c-0.2-1.2,0.4-3.8,0.4-3.8c-0.2,1,0.4,2.6,0.6,3.5   c0.6,2.2,1.6,3.7,1.8,5.1C82.6,27.3,82.4,29,79.1,29.7z M87.9,22.3c-0.8,0-1.4-0.6-1.4-1.4c0-0.8,0.6-1.4,1.4-1.4   c0.8,0,1.4,0.6,1.4,1.4C89.3,21.6,88.7,22.3,87.9,22.3z M14.6,19.1c-2.3,4.4,0.2,7,3.1,7.9l0-0.1c0.1,0,0.2,0,0.2,0.1c0,0,0.1,0.1,0.1,0.1c1.4,0.4,2.9,0.4,4,0   c2.7-0.9,3.3-2.5,3.4-3.4c-0.2-2.4-1.3-5.7-4.3-7.2c0,0.4,0.1,0.8,0.1,1.1c0.1,1.3-0.2,1.6,0.3,2.2c0.5,0.7,0.6,2.4-0.4,2.3   c-1-0.1-0.9-1.5-0.7-2.4c0.1-0.7,0-2.6,0-3.6c0,0,0,0,0,0c-0.2-1.9-1.8-4.3-1.8-4.3s-0.1,1.1-0.6,1.7c-0.5,0.6-1.1,1.7-1.1,1.7l0,0   C16.1,16.2,15.4,17.4,14.6,19.1z'
      ref={ref => pathRefs.push(ref)}
    />
  );

  content.push(
    <path
      key='dog2'
      className={styles.dog}
      d='M75.4,63.2l-4.9,7.7c0,0,0.4,4.1,0,6.2c-0.4,2.1-1.1,7.5-0.9,8.8c0.2,1.3,0,1.7,2.1,2.6c2.1,0.9,10,1.3,7.5-3.2   C76.7,80.7,77.7,70.4,75.4,63.2z M27.4,67.1c-0.9,2.8-3.2,7.9-10.9,11.5c0,0-1.9,1.3-2.1,2.8c-0.2,1.5,1.9,7.3,6,7.3c4.1,0,8.1-1.7,5.3-4.9   c-2.8-3.2,0.5-6.8,2.4-8.5c3.4-3.2,3.2-11.1,3.2-11.1S28.3,64.3,27.4,67.1z M85.9,4.6c-0.5-0.6-3.8,0.6-3.8,0.6s3.4,1.4,4.5,2.4C86.5,7.6,86.4,5.2,85.9,4.6z M98.9,25.2c0.1-1.3,0.1-2.4-0.1-2.8c-0.3-1-5.1-3.8-6.1-5.4c-1.5-2.5-5.8-6.4-5.8-6.4c-2.1-1.9-4.1-3-5.9-3.4   C81,9.3,80.5,16.4,79,17.5c-1.7,1.3-6-1.5-6.4-3.6C72.2,11.8,72,8.8,72,8.8s1.5,3,1.9,4.3c0.4,1.3,3.6,3.6,4.3,2.4   c0.5-1,1-6.5,1.2-8.6c0,0,0,0,0,0c0.1-0.9,0-1.6-0.1-1.8c-0.6-0.6-3.8,0.6-7.3,1.3c-2.3,0.4-2.3,3-2,4.9c-3.4,3.2-6.1,7.3-6.1,7.3   C48.4,37.8,30,34.4,22.7,35.5c-1.8-3.9-0.4-11.2,1.8-15.4c3.5-6.7-0.3-8-1.9-6.7c-1.6,1.3-4.7,9.6-5.8,13.1   c-1.6,5.2-0.9,9.9-0.4,12.2c-3.3,2.4-6.1,6.2-7.9,15.7C5.9,67.9,2.7,70.1,1.4,73.7c-1.3,3.5,0.6,17.6,0.6,17.6   c1,5.4,10.3,4.2,10.3,4.2s3.5-2.9,1.3-5.4c-2.2-2.6-2.2-5.1-2.2-5.1c0.6-3.5,2.6-6.5,5.5-8.5c3.4-2.3,7.5-5.7,8.6-9.2   c1.9-6.1,6.1-4.8,6.1-4.8c10.9,5.4,20.8,2.2,21.5,3.8c0.6,1.6,0.3,11.2,0.3,11.2c-0.3,6.4,1.9,11.2,1.9,11.2c0.3-1.9,1-4.2,1-4.2   c0.6,2.2,0.6,7.1,3.2,9c2.6,1.9,8.3,1.3,9.3,0.6c1-0.6-0.3-4.5-0.6-8.3C67.8,82,68.8,75.3,68.8,74c0-1.3-1.9-8.7-2.2-10.3   c-0.3-1.6,1-10.3,1-10.3s0.6,3.8,0.6,5.4c0,1.6,1.9,9.3,1.9,9.3s4.5-7.1,5.1-9.6s1-13.1,1-14.7c0-1.2,0.8-6.5,1.3-9.3   c0.2-1,1.2-1.7,2.2-1.3c1.9,0.7,3.5,1.6,4.2,2.3c1,1,5.4,9.3,5.4,9.3l1-5.4l1.6,4.2c0-3.2,1.3-5.8,1.3-5.8l1.6-5.1l1,4.8l1.6-4.5   c0,0-0.3,1.3,0.6-1.9c0.4-1.4,0.7-3,0.9-4.5c-0.6,0.2-1.7-0.3-2.7-1.1c-1.1-1-0.2-3-0.2-3C96.4,24.8,97.9,25.2,98.9,25.2z    M86.5,20.5c-1,0-1.8-0.8-1.8-1.8c0-1,0.8-1.8,1.8-1.8s1.8,0.8,1.8,1.8C88.3,19.7,87.5,20.5,86.5,20.5z'
      ref={ref => pathRefs.push(ref)}
    />
  );

  content.push(
    <path
      key='dog3'
      className={styles.dog}
      d='M32.9,73.9l-3.7-1.2c0,0-6.4,7.6-10.3,9.8v8.3c0,0,0.2,2.2,2.5,2.2c2.2,0,5.9,0.5,7.4-1.5s-2.7-3.7-2.7-3.7s-0.2-4.2,1-5.6   C28.3,80.8,32.9,73.9,32.9,73.9z M85.7,91.4C85.7,91.4,85.7,91.3,85.7,91.4C85.7,91.3,85.9,91.8,85.7,91.4z M85,84.2c-0.2-2,2.9-12.8,2.9-12.8l-5.4,3.4c0,0-1.7,7.9-1.7,9.8s0.7,3.4,0.7,3.4s2.7-0.2,3.7,2c0.3,0.7,0.5,1,0.5,1.2   c0.4,0.1,3.3,0.9,2.4-3.2C87.2,83.7,85.2,86.2,85,84.2z M98.9,37.4c-0.5-6.1-4.2-9.6-4.2-9.6c-3.4,1.5-5.9,4.9-5.9,4.9c-0.7-1.2,2-4.2,2-4.2c5.2-4.2,7.1-7.6,7.4-8.6   c0,0-2.2-1-3.4-3.9c0,0,1.7,2.3,3.6,2.2c0.1-1.9-0.1-4.5-1.7-4.1c-2.2,0.5-9.3-0.2-9.3-0.2c0-1.5-1.7-5.4-1.7-5.4S84,2.5,75.6,2.3   S58.9,5.5,56.2,14.1c0,0-6.4-0.7-8.1-3.2c0,0,0,8.6-0.5,10.3c0,0-2.4,8.5-7.3,13.2s-18.5,5.2-18.5,5.2c4.5-0.2,14.5-5,15.9-6.1   c3.9-3.1,5.5-8.3,5.5-8.3l-4.2,0.7c0,0,0,0,1.7-2c1.7-2,4.9-11.8,4.9-11.8s-8.6,2.9-12.5,3.7c-3.9,0.7-25.8,8.1-23.6,19.4   c0,0-9.3,15.7-8.6,22.6c0.5,5,1.3,7.5,2.5,10.5c1,2.6,1.5,5.3,1.5,8c0,4.4-0.1,11.1-1.1,14.8c-1.5,5.9,2.9,6.6,6.4,6.6   c3.4,0,5.2-1.5,5.2-3.4s-3.7-2.7-3.4-5.4c0.2-2.7,0.7-5.6,5.4-8.6c4.7-2.9,11.5-11,11.5-11c7.9,3.4,22.8,1.2,29.9,5.4   c5.8,3.4,11.8,15.6,13.8,20c0.4,1,1.4,1.6,2.4,1.6h6.3c1.7,0,2.9-1.7,2.9-1.7C84,89.6,80,90.1,80,90.1l-1.2-3.3   c-0.6-1.7-0.7-3.5-0.3-5.2c0.5-2.1,1.1-4.9,1.1-6c0-1.7,5.6-5.2,5.6-5.2c3.7-0.7,8.8-9.3,10.3-10.8C97,58.2,99.4,43.5,98.9,37.4z    M71.9,15.8c-1.2,1.5-2.7,4.4-2.7,4.4c-0.2-3.7,1.5-4.7,1.5-6.1c0-1.5-1.5-4.9-3.4-4.7c-2,0.2-3.7,2.9-3.7,2.9   c-0.7-2.5,2-5.4,5.2-5.2C71.9,7.4,73.2,14.3,71.9,15.8z M79.1,18c0,0,0.5-3.2,2.2-3.4c1.7-0.2,2.2,2.2,2.2,2.2   C81.5,20.7,79.1,18,79.1,18z'
      ref={ref => pathRefs.push(ref)}
    />
  );

  content.push(
    <path
      key='dog4'
      className={styles.dog}
      d='M8.6,78.4c0,0-1.4,2.1-1.1,4.5C7.9,85.3,8.3,89,8.3,89s2.6,1,2.7,2.6c0,0,3.4-0.2,2.3-2.6c-1.1-2.4-2.6-1.8-2.6-5   s1.1-6.6,3.2-9.4L8.6,78.4z M71.8,88.2c0,0-0.8-5-1-8.3c-0.2-3.2,0.3-16.2,0.3-16.2s-1.4,1.1-2.6,1.4c0,0-0.5,6.1,0.2,16.2c0.3,4.6,1.6,8.6,1.7,8.4   c0,0,1.7,0.7,1.4,2.4c0,0,2.9,0.2,2.4-2.2C74.1,90,73.7,88.5,71.8,88.2z M98.4,24.8c0,0-4.8-1.4-5.9-1.9c-1.1-0.5-2.1-1.4-2.6-2.9c-0.5-1.4-6.3-4-6.9-4c-0.6,0-1-3.7-0.8-6.3   c0.1-1.7-0.6-3.3-1-4.2c-0.1-0.3-0.6-0.2-0.6,0.1L80,8c-0.6,3.2-4.3,7.1-4.3,7.1c-9,7.3-10.9,11.8-15,14.6S29,36.5,26.4,37.1   c-2.6,0.6-7.9,3-10.3,3.4s-7.5-3-9.2-1.7c-1.7,1.3-0.6,2.6-0.6,2.6l4.8,2.7c0.4,0.2,0.5,0.8,0.2,1.1c-2,2.5-1.4,7.5-0.9,13.5   C11,68.4,3,71.8,2.4,72.3c-0.3,0.2-0.6,0.6-0.9,1.1C1.1,74,0.9,74.7,1,75.5c0.4,3.4,1.6,13.7,1.6,15.9c0,2.6,1.1,2.6,1.1,2.6   s6,0.6,6-1.5s-2.8-2.1-2.8-2.1s-1.7-9.9,0-12.4c1.7-2.6,8.8-4.5,12.2-10.5c3.4-6,9.4-10.9,13.5-10.7c4.1,0.2,26.5,3.5,26.5,3.5   l2.3,21c0,0.7-0.3,2.7,0.1,3.2c0.9,1.2,1.6,3.6,1.7,4.3c0.1,0.6,1.6,3.4,2.4,4.9c0.3,0.6,0.9,1,1.6,1.1c1.3,0.2,3.3,0.2,3.4-1   c0.2-1.8-1.6-2.4-1.6-2.4c-1.4-2.9-1.9-6.9-1.9-6.9s-0.8-10.8-0.8-14.5c0-2.3,0.6-8.7,0.6-9.2c0-0.5,1-2.3,2.1-3.4   c1.1-1.1,2.3-3.4,2.3-3.4c-0.5,3.4-1.9,4.5-2.3,5.3c-0.3,0.8-0.5,4.2-0.5,4.2l1.6-1.1c3.2-2.7,4.3-6.8,4.5-7.9   c0.2-1.1,0.3-10.5,0.3-10.5l3.9-11.4l1.6-3.5c1.3,0,7.2,1.9,9.3,1.9c2.1,0,3.5-0.2,5.1-0.5c1.4-0.3,2.5-1.9,2.8-2.4   c-0.4-0.4-0.9-1.3-1-2.4c0,0,0.7,1.5,1.5,1.7c0.1-0.1,0.2-0.3,0.4-0.5C99.5,25.6,98.4,24.8,98.4,24.8z M86.9,20.2l1.6,0.2l0.8,1.3   C87.5,21.8,86.9,20.2,86.9,20.2z'
      ref={ref => pathRefs.push(ref)}
    />
  );

  content.push(
    <path
      key='dog5'
      className={styles.dog}
      d='M98.6,27.4c0.3-0.8,0.4-1.4,0.3-1.7c-0.5-1.3-5.6-2.8-8.2-4.3c-1.5-0.9-2.1-2.1-2.2-2.9c-0.2-1-0.7-1.9-1.4-2.6  c-3.2-2.9-9.1-2.4-10.7-2.4c-1.8,0-5.4,1.8-6.6,3.1c-1.3,1.3-6.6,6.4-6.6,6.4C60.1,26,52.4,29.4,48,30.6c-4.4,1.2-24.2,2.4-28.6,3.7  c-1.3,0.4-2.3,1.2-3.1,2.3c0-0.2,0.1-0.3,0.1-0.3s-3.7,1.2-4.8,3.2c0,0-1.7,2-1.5,6.6c0.2,4.6-1.2,12.4-1.2,12.4s2.7-4.9,4.5-10.4  c0,0.4-0.1,0.8-0.1,1.2c-0.7,8-4.8,13.6-8.3,16C1.3,67.8,1,69.9,1,69.9c2,3.1,1.9,14,2.7,14.6C4.6,85.2,6.1,85,9.5,85  c3.4,0,3.9-1.5,3.7-2.9c-0.2-1.4-2.4-1.7-2.4-1.7c-2.4-0.2-3.7-3.1-3.7-3.1c1.4,1.4,6,2,8,1c2-1,5.4-7.3,5.4-7.3  c-0.3,2.4-1.4,4.8-1.4,4.8c1.7-0.2,4.1-2.7,4.1-2.7c1.5-3.1,1-4.4,2.7-7.8c1.7-3.4,13.3-2,16.7-1.7c3.4,0.3,6.5,5.1,6.5,5.1  c0.5-1.5,2.7-3.2,2.7-3.2c-3.6,7.8-1.2,12.4-1.2,12.4c-0.5-1,0.7-3.4,0.7-3.4l1.5-3.4c0,0,0.9,1.7-0.5,5.1c-1.4,3.4,0.5,7.1,0.5,7.1  s2.2-1.2,2-0.5c-0.2,0.7-2,2.6-2,2.6s2,0.7,4.4,0.7c2.4,0,4.4-1.4,4.4-1.4c3.4,3.6,7.3,1.4,8.3,0.9c1-0.5,0.9-3.2-1.4-3.4  c-2.2-0.2-2.2-4.3-2.2-4.3s-0.2-4.8-0.2-7.8c0-2.6,2.4-6.9,3.7-8.7c-1.8,4.3-2.3,8-2.3,8s1.2,2,1.5,2.9c0.3,0.9,0.2,2.6,0.2,2.6  s1.5-2.9,1.4-3.9c-0.2-1-1-3.2-1-3.2s1.5,2.2,2.2,3.1c0.7,0.9,0.9,4.1,0.9,4.1s2-3.1,0.7-5.4c-1.4-2.4-1.2-5.1-1.2-5.1  s0,1.5,1.5,3.2s3.2,4.8,3.2,4.8s1.5-1.5-0.3-4.6c-1.9-3.1-1-6.6-1-6.6c0.3,4.8,3.1,6.1,3.1,6.1s-0.9-4.3,0-7.1  c0.9-2.9-0.2-7.3-0.2-7.3c-3.4,3.6-6,3.7-6,3.7c-4.8,2-6.8-1.4-6.8-1.4L64,50.6c-1.3-3.3-1-5.4,0.3-8.9c1.3-3.6-0.3-7.4,2.6-8.9  c2.8-1.5,4.9-7.7,4.9-7.7l-1,5.1c0,0-2.3,4.3-3.1,5.6c-0.8,1.3-0.8,6.4-0.8,6.4s-1.5,4.2-1.3,5.1c0.5,2.5,1.3,4.6,2.3,6.1  c1,1.5,5.6,2,9.4-2c3.8-4.1,2.8-7.1,4.1-8.9c1.3-1.8,0-6.9,0-6.9L80.1,33c1.5-3.3,1-9.7,1-9.7c1.5,3.3,1.3,9.2,1.3,9.2  c4.6,0.8,11.7,0.8,12.8,0.3c0.6-0.3,2.2-2.6,3.1-4.5c-0.5-0.3-1.2-1-1-2.4C97.2,25.9,97.3,26.7,98.6,27.4z M87.6,21.9  c-0.5,1-2.4-0.2-2.4-0.2l1.9-2.6C88.4,20.7,87.6,21.9,87.6,21.9z'
      ref={ref => pathRefs.push(ref)}
    />
  );

  content.push(
    <path
      key='dog6'
      className={styles.dog}
      d='M98.7,28.5c-0.8-0.4-1.6-1-2.2-2c0,0,0.9,0.5,2,0.8c-0.5-1.8-1.3-3.2-2.9-2.5c-3,1.3-5.4-2.3-4.3-4.7s-0.2-6.3-5.9-8.3   c-5.7-2-15.4,1.1-17.9,5.1l-4.3,7.6c0,0-7.9,13.3-7.5,17.1c0.5,3.8,17.2,6.4,17.2,6.4l1.7-0.3c1.7-0.3,3-1.9,2.8-3.6   c-0.6-7.3-2.6-22.7-2.6-22.7c1.8,5.8,4.8,20.7,4.8,20.7s0,0,0,0c0,0.3,0.7,4.4-0.9,6.3c-1.2,1.3-3.3,2.7-8,2.6   c-4.7-0.1-12.3-4.1-12.3-4.1s-6.8-1.8-4.8-9.4l2.3-4.3c0,0-5.2,2.1-11.8,1.7S22,30,17.8,31.3c-1.2,0.4-2.7,1-4.2,1.9   c0-0.1,0-0.1,0-0.1s-5.5,1.5-8,4c-2.5,2.4-5.9,5.9-4.2,6.8c1.1,0.6,3.2,0.3,5-0.5c0,0.3-0.1,0.6-0.1,0.9C5.7,51.9,9,64.6,8.9,68.4   c-0.1,3.8,0,1.1,0.4,8.5c0.4,7.4,0.4,10.2,5.8,11.6c5.5,1.5,10.4-1.4,10.2-4.2c-0.2-2.7-4-5.3-3.9-10.8c0.1-5.5,4-9,4.9-12.5   c0,0,23.5,6.2,26.5,5.7c0,0-0.7-8,0.8-12.6c0,0,1.4,12.4,2.2,14l2.5,14.6c0,0,1,4.1,4.9,4.2c3.8,0.1,12,0.8,10.2-5.6   c0,0,0,0-2.4-4.4c-2.4-4.4,0.2-10.1,3-14.2c2.8-4.1,7.9-9.4,8.2-12.7c0.2-2.2,0.9-4.6,1.4-6c3,0.9,6.9,1.5,6.9,1.5   c-1.1,0-2.1-3.6-2.1-3.6c1.3,2.2,4.9,2.8,4.9,2.8s-0.5-3,1.5-4.6c1.9-1.6,4.3-7.3,4.3-8.7C99,30.9,99,29.8,98.7,28.5z M82.1,26.2   c0,0,1.4-3,2.5-3c1.1,0,2.7,2,2.7,2C85.3,29,82.1,26.2,82.1,26.2z M80.9,73.9c-1.6-1.1-1.3-6.1-0.7-7.7c0.6-1.6,2.8-4.3,1.8-9.6l-2,2.4c0,0-6.5,8.7-6.5,10c0,1.4-1.2,3.5,0.7,8   c1.8,4.4,1.8,4.4,1.8,4.4s9.5,2.9,8.3-4C84.4,77.5,82.6,75,80.9,73.9z M30,69.3l-0.2-3.8l-2.2-0.9l-1.4,1.9c0,0-2.6,5.2-2.3,7.1c0.2,1.9,2.6,6.4,2.6,6.4s8.5,2.6,7.7-2.3   C33.5,72.7,31,75.1,30,69.3z'
      ref={ref => pathRefs.push(ref)}
    />
  );

  return {
    content,
    pathRefs,
  };
}

/*****************************************
 * * Create Animation
 *****************************************/
export function createAnim2(anim, pathRefs, speed) {
  anim.clear();
  anim.add(
    anim.to(
      pathRefs[0],
      {
        duration: speed,
        morphSVG: {
          shape: pathRefs[1],
          type: 'linear',
          map: 'size',
        },
        // ease: 'power1.inOut',
        opacity: 1,
      },

      '+=0.5'
    )
  );

  // map: size | position | complexity
  // type: linear | rotational
  anim.add(
    anim.to(
      pathRefs[0],
      {
        duration: speed,
        morphSVG: {
          shape: pathRefs[2],
          type: 'linear',
          map: 'size',
        },
        // opacity: 1,
        // ease: 'power1.inOut',
      },

      '+=0.5'
    )
  );
  anim.add(
    anim.to(
      pathRefs[0],
      {
        duration: speed,
        morphSVG: {
          shape: pathRefs[3],
        },
      },

      '+=0.5'
    )
  );
  // anim.add(
  //   anim.to(
  //     pathRefs[0],
  //     {
  //       duration: speed,
  //       morphSVG: {
  //         shape: pathRefs[4],
  //       },
  //     },

  //     '+=0.5'
  //   )
  // );
  anim.add(
    anim.to(
      pathRefs[0],
      {
        duration: speed,
        morphSVG: {
          shape: pathRefs[5],
        },
      },

      '+=0.5'
    )
  );

  anim.add(
    anim.to(
      pathRefs[0],
      {
        duration: speed,
        morphSVG: {
          shape: pathRefs[4],
        },
      },

      '+=0.5'
    )
  );

  anim.add(
    anim.to(
      pathRefs[0],
      {
        duration: speed,
        morphSVG: {
          shape: pathRefs[0],
        },
      },

      '+=.5'
    )
  );
}
